import React from 'react';
import { ResponsiveGrid, Tab } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import styles from './index.module.scss';
import BAList from '../BA/components/BAList';
import BARecord from '../BA/components/BARecord';
import BADeviceList from '../BADevice/components/BADeviceList';

const { Cell } = ResponsiveGrid;

const SmartBuilding = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="e化整合管理"
        breadcrumbs={[
          {
            name: '智慧建築專區',
          },
          {
            name: 'e化整合管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <Tab>
        <Tab.Item title="BA監控介面整合">
          <div className={styles.content}>
            <h2>BA監控介面整合</h2>
            <BAList />
          </div>
        </Tab.Item>
        <Tab.Item title="BA裝置列表">
          <div className={styles.content}>
            <h2>BA裝置列表</h2>
            <BADeviceList />
          </div>
        </Tab.Item>
        <Tab.Item title="BA裝置記錄">
          <div className={styles.content}>
            <h2>BA裝置記錄</h2>
            <BARecord />
          </div>
        </Tab.Item>
      </Tab>
    </Cell>
  </ResponsiveGrid>
);

export default SmartBuilding;
